import type { KeyboardEvent } from 'react';

export const focusElement = (element: HTMLElement | null, e: KeyboardEvent) => {
  if (!element) {
    return;
  }

  element.focus();
  e.preventDefault();
};
